export default __webpack_public_path__ + "static/media/eyetest.c0e55a40.png";